import { Injectable } from '@angular/core';
import {
  ICreateLamina,
  IDispositivo,
  ILamina,
  IQueryParam,
  IUpdateLamina,
  Semaforo,
} from 'modelos/src';
import { Observable } from 'rxjs';
import { HelperService } from 'src/app/auxiliares/helper.service';
import { apiBase } from 'src/environments/environment';
import { HttpService } from '../../../auxiliares/http.service';
import { LoginService } from '../../login/login.service';
import { IConfigs } from '../../offline/configuracion-canal/bluetooth.service';

const api = apiBase;

export interface IDispositivoTabla extends IDispositivo {
  nivelCalculado?: number;
  semaforo?: Semaforo;
}

export interface ILaminaTabla extends ILamina {
  nivelCalculado?: number;
  semaforo?: Semaforo;
}

export interface ILaminaMapa extends ILamina {
  polygonOptions?: google.maps.PolygonOptions;
  nivelCalculado?: number;
  semaforo?: Semaforo;
}

export interface ILaminaDetalles extends ILamina {
  polygonOptions?: google.maps.PolygonOptions;
  nivelCalculado?: number;
  semaforo?: Semaforo;
}

@Injectable({
  providedIn: 'root',
})
export class SlalService {
  public cliente? = LoginService.getCliente();

  constructor(private http: HttpService) {}

  // Laminas
  public getLamina(id: string): Observable<ILamina> {
    return this.http.get(`${api}/laminas/${id}`);
  }
  public getLaminas(queryParams?: IQueryParam): Observable<{
    data: ILamina[];
    total: number;
  }> {
    const params = HelperService.getQueryParams(queryParams);
    return this.http.get(`${api}/laminas`, { params });
  }
  public createLamina(data: ICreateLamina): Observable<ILamina> {
    return this.http.post(`${api}/laminas`, data);
  }
  public updateLamina(id: string, data: IUpdateLamina): Observable<ILamina> {
    return this.http.put(`${api}/laminas/${id}`, data);
  }
  public deleteLamina(id: string): Observable<ILamina> {
    return this.http.delete(`${api}/laminas/${id}`);
  }

  public config(deveui: string, config: IConfigs) {
    return this.http.post(`${api}/comandos/laminas/config`, {
      deveui,
      config,
    });
  }

  // Helper

  private fechaAyer() {
    const fecha = new Date();
    fecha.setDate(fecha.getDate() - 1);
    return fecha;
  }

  public estadoDispositivo(dato: IDispositivo) {
    const ayer = this.fechaAyer();
    const ultimoReporte = dato.ultimoReporte?.fecha
      ? new Date(dato.ultimoReporte.fecha)
      : null;
    const ultimaAlerta = dato.ultimaAlerta?.fecha
      ? new Date(dato.ultimaAlerta.fecha)
      : null;
    if (ultimaAlerta) {
      if (!ultimoReporte || ultimaAlerta > ultimoReporte) {
        return 'Alerta';
      }
    }
    if (!ultimoReporte || ayer > ultimoReporte) {
      return 'Sin reportar';
    }
    return 'Ok';
  }

  public calcularAltura(distancia: number, cota?: number): number {
    if (cota) {
      return cota - distancia;
    } else {
      return distancia;
    }
  }

  public getSemaforo(lamina: ILaminaTabla) {
    // Busca el color en la configuracion de la lamina
    const nivel = lamina.nivelCalculado || 0;
    let find = lamina.configuraciones?.coloresNivel?.find((l) => {
      return nivel < l.valorHasta && nivel >= l.valorDesde;
    });

    // Si no encuentra el color en la configuracion de la lamina, busca en la configuracion del cliente
    if (!find) {
      find = this.cliente?.configuraciones?.lamina?.coloresNivel?.find((l) => {
        return nivel < l.valorHasta && nivel >= l.valorDesde;
      });
    }
    return find;
  }

  public async exportarReportes(
    queryParams?: IQueryParam,
    filename = 'reportes.xlsx',
  ): Promise<void> {
    const params = HelperService.getQueryParams(queryParams);
    await this.http.getFile(
      `${api}/reportes/exportar/laminas`,
      filename,
      params,
    );
  }

  public estadoLamina(dato: ILamina) {
    const limite = this.fechaHaceXHoras(6);
    const ultimaComunicacion = dato.ultimaComunicacion
      ? new Date(dato.ultimaComunicacion)
      : null;

    if (!ultimaComunicacion || limite > ultimaComunicacion) {
      return 'Sin reportar';
    }

    return dato.ultimoEstado;
  }

  private fechaHaceXHoras(horas: number) {
    const fecha = new Date();
    fecha.setHours(fecha.getHours() - horas);
    return fecha;
  }
}
